import { Profil } from './../../../models/Profil';
import { ProfilService } from './../../../services/profil.service';
import { AuthService } from './../../../services/auth.service';
import { AgentService } from './../../../services/agent.service';
import { Agent } from './../../../models/Agent';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { SelectItem, Message, ConfirmationService } from 'primeng/primeng';
import { ClientsService } from 'src/app/services/reporting/clients.service';

@Component({
  selector: 'app-agent',
  templateUrl: './agent.component.html',
  styleUrls: ['./agent.component.css']
})
export class AgentComponent implements OnInit {

  colorFieldset = 'primary';
  colorPanel = 'primary';
  droit: boolean;
  titre = 'Gestion des Agents';
  msgs: Message[] = [];
  growlDefaultLife: number;
  items: Agent[] = [];
  items$: Observable<Agent[]>;
  item: Agent;
  editMode = false;
  displayDialog = false;
  itemId: any;
  totalElements: number;

  confirmation: string;
  listProfil: SelectItem[];
  listPdg: SelectItem[];
  listRole: SelectItem[];
  listPoint: SelectItem[];
  listCategorie: SelectItem[];

  searchLibelle: string;
  searchPoint: string;
  searchProfil: string;
  libelle: string = "";
  displaychargement: boolean;
  formValid = false;
  form: FormGroup;
  formErrors = {
    login: '',
    password: '',
    nom: '',
    prenom: '',
    profil: '',
    email: '',
    telephone: '',
    role: '',
    nomPdg: '',
    confirmer: ''
  };
  validationMessages = {
    login: { required: 'Login est requis.' },
    password: { required: 'Mot de passe est requis.' },
    confirmation: { required: 'Confirmation est requis.', confirm: 'Mot de pass non conforme.' },
    nom: { required: 'Nom est requis.' },
    prenom: { required: 'Prenom est requis.' },
    profil: { required: 'Profile est requis.' },
    email: { required: 'Email est requis.', pattern: 'Email format est invalide.' },
    telephone: { required: 'Telephone est requis.' },
    nomPdg: { required: 'Telephone est requis.' },
    role: { required: 'role est requis.' }
  };

  profils: any[];
  agents: any[];
  constructor(private fb: FormBuilder,
    private router: Router,
    private profilService: ProfilService,
    private agentService: AgentService,
    private authService: AuthService,
    private clientsService: ClientsService,
    private confirmationService: ConfirmationService) {
  }

  ngOnInit() {
    this.buildForm();
    this.getAgents();
    this.getProfil();
  }

  paginate(rows, page) {

  }
  async search() {
    this.close();
    if(this.libelle === '' || this.libelle === null || this.libelle === undefined) {
      this.getAgents();
    } else {
      this.agents = (await this.agentService.getAgentByLogin(this.libelle).toPromise() as any);
    }
  }
  onChangePoint(value) {
    this.searchLibelle = '';
    this.searchPoint = value;
    this.searchProfil = '';
    this.paginate(10, 0);
  }
  onChangeProfil(value) {
    this.searchLibelle = '';
    this.searchPoint = '';
    this.searchProfil = value;
    this.paginate(10, 0);
  }

  selectElement(event) {
    this.editMode = true;
    this.item = this.cloneObject(event.data);
    this.displayDialog = true;
    this.router.navigate(['/agent-detail', this.item.login]);
  }
  editElement(data) {
    this.editMode = true;
    this.item = this.cloneObject(data),
      console.log('item: ', this.item);
    this.displayDialog = true;
    if (!this.item.profil) {
      const profil = this.profils[0];
      this.item.profil = {
        id: profil && profil.id
      };
    }
    this.buildForm();
  }
  newElement() {
    this.editMode = false;
    this.item = null;
    this.displayDialog = true;
    const profil = this.profils[0];
    this.buildForm();
    this.form.get('profil').setValue(profil && '' + profil.id);
  }
  delElement(id: any) {
    this.confirmationService.confirm({
      message: 'Voulez-vous désactiver cet Agent ?',
      accept: () => {
        this.delete(id);
      }
    });
  }
  activerElement(id) {
    this.confirmationService.confirm({
      message: 'Voulez-vous activer cet Agent ?',
      accept: () => {
        this.activer(id);
      }
    });
  }
  deconnecterElement(a) {
    this.confirmationService.confirm({
      message: 'Voulez-vous deconnecté cet Agent : ' + a.login + ' ?',
      accept: () => {
        this.deconnecter(a);
      }
    });
  }
  deconnecter(a) {
    this.authService.logout(a.login).subscribe(data => {
      this.msgs = []; this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Agent deconnecté avec succès' });
    });
  }
  save() {
    if (this.editMode) {
      this.displaychargement = true;
      this.agentService.update(this.item).subscribe(data => {
        this.displaychargement = false;
        this.displayDialog = false;
        // this.item = data;
        this.items[this.findItemIndex(this.item.login)] = this.item;
        this.msgs = []; this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Modification effectuée' });
      }, error => { this.displaychargement = false; console.log(error); });
    } else {

      this.item.etat = true;
      this.displaychargement = true;
      this.agentService.save(this.item).subscribe(
        data => {
          // this.item = data;
          this.items.push(this.item);
          this.displaychargement = false;
          this.displayDialog = false;
          this.item = null;
          this.msgs = []; this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Agent crée avec succès' });
          this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Magasin crée avec succès' });

        }, error => { this.displaychargement = false; console.log(error); });
    }
  }
  async delete(id: any) {
    this.displaychargement = true;
    try {
      const data = await this.agentService.delete(id).toPromise();
      this.msgs = []; this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Suppression effectuée' });
      await this.getAgents();
    } catch (error) {
      this.msgs = []; this.msgs.push({ severity: 'warning', summary: 'Confirmation', detail: 'Suppression échouée' });
    } finally {
      this.displaychargement = false;
    }
  }

  async activer(id) {
    this.displaychargement = true;
    try {
      const data = await this.agentService.activer(id).toPromise();
      this.msgs = []; this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Suppression effectuée' });
      await this.getAgents();
    } catch (error) {
      this.msgs = []; this.msgs.push({ severity: 'warning', summary: 'Confirmation', detail: 'Suppression échouée' });
    } finally {
      this.displaychargement = false;
    }
  }


  close() {
    this.item = null;
    this.displayDialog = false;
  }

  cloneObject(c: Agent): Agent {
    return Object.assign({}, c);
  }
  findItemIndex(id): number {
    this.itemId = id;
    return this.items.findIndex(this.testItemId, this);
  }
  testItemId(value, index, array): boolean {
    return value.login === this.itemId;
  }

  loadSelectList() {
  }

  async getProfil() {
    this.profils = (await this.agentService.getProfils().toPromise() as any);
    this.listProfil = this.profils.map(e => {
      return { label: e.titre, value: Number(e.id) };
    });
    const profil = this.profils[0];
    this.form.get('profil').setValue(profil && profil.id && Number(profil.id));

    this.listPdg = [];
    this.listPdg.push({ label: 'Distributeur...', value: null });
    try {
      let dataRetourPdg = <any>await this.clientsService.findAgents().toPromise();
      for (let el of dataRetourPdg) {
        this.listPdg.push({ label: el.login + " - " + el.msisdn, value: el.login });
      }
    } catch (error) { }

    

    this.listRole = [];
    this.listRole.push({ label: 'ROLE...', value: null });   
    this.listRole.push({ label: 'PARTENAIRE', value: 'PARTENAIRE' }); 
    this.listRole.push({ label: 'ADV', value: 'ADV' }); 
    this.listRole.push({ label: 'TRESORERIE', value: 'TRESORERIE' }); 
    this.listRole.push({ label: 'DAL', value: 'DAL' }); 
    //this.listRole.push({ label: 'TRESORERIE_OMY', value: 'TRESORERIE_OMY' }); 
    //this.listRole.push({ label: 'SUPPORT_DD', value: 'SUPPORT_DD' }); 
    //this.listRole.push({ label: 'COMPTA', value: 'COMPTA' }); 
    //this.listRole.push({ label: 'MAGASIN_CHEF', value: 'MAGASIN_CHEF' }); 
    //this.listRole.push({ label: 'MAGASIN_AGENT', value: 'MAGASIN_AGENT' }); 
    //this.listRole.push({ label: 'TRESORERIE_OMY_SUP', value: 'TRESORERIE_OMY_SUP' }); 

    console.log('Profil::', profil, this.form.get('profil').value);

  }
  get regexPassword() {
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=!*()@%&]).{8,100}$/;
  }

  async getAgents() {
    this.agents = (await this.agentService.getAgent().toPromise() as any);
  }

  buildForm() {
    this.form = this.fb.group({
      login: [this.editMode && this.item && this.item.login || '', [Validators.required]],
      nom: [this.editMode && this.item && this.item.nom || '', [Validators.required]],
      password: [this.editMode && this.item && this.item.password || '', [Validators.required]],
      confirmer: [this.editMode && this.item && this.item.confirmer || '', [Validators.required]],
      prenom: [this.editMode && this.item && this.item.prenom || '', [Validators.required]],
      profil: [this.editMode && this.item && this.item.profil && this.item.profil.id || '', [Validators.required]],
      role: [this.editMode && this.item && this.item.role || '', [Validators.required]],
      email: [this.editMode && this.item && this.item.email || '', [Validators.required]],
      nomPdg: [this.editMode && this.item && this.item.login || '', [] ],
    });
    console.log(';:::::::::', this.form.value);
  }

  async saveAgent() {
    console.log(':::::', this.form.get('profil').value);
    console.log('form: ', this.form.value);
    console.log('fin');
    const dataToSend = {
      login: this.form.value.login,
      nom: this.form.value.nom,
      prenom: this.form.value.prenom,
      password: this.form.value.password,
      email: this.form.value.email,
      profil: { id: Number(this.form.value.profil) },
      role: this.form.value.role,
      nomPdg: this.form.value.nomPdg
    };

    if (!(new RegExp(this.regexPassword)).test(this.form.value.password)) {
      this.msgs = [];
      this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Le mot de passe est faible' });
      return;
    }

    if (!this.editMode && this.checkForm()) {
      return;
    }

    if (this.form.value.password !== this.form.value.confirmer) {
      this.msgs = [];
      this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Le mot de passe n\'est pas vérifié' });
      return;
    }
    console.log('dataToSend: ', dataToSend);
    try {
    this.displaychargement = true;
      const data = await (!this.editMode ? this.agentService.save(dataToSend).toPromise() : this.agentService.modify(dataToSend).toPromise());
      this.msgs = []; this.msgs.push({ severity: 'warning', summary: 'info', detail: 'Tratitement effectué avec succès' });
      this.item = new Agent();
      await this.getAgents();
      this.displayDialog = false;
    } catch (error) {
      console.error('Error:', error);
      this.msgs = []; this.msgs.push({ severity: 'warning', summary: 'info', detail: 'Tratitement échoué' });
    } finally {
      this.displaychargement = false;
    }
  }

  checkForm() {
    if (this.form.value.login === '' || this.form.value.login === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'warning', summary: 'info', detail: this.validationMessages.login.required });
      return true;
    }
    if (this.form.value.nom === '' || this.form.value.nom === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'warning', summary: 'info', detail: this.validationMessages.nom.required });
      return true;
    }
    if (this.form.value.prenom === '' || this.form.value.prenom === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'warning', summary: 'info', detail: this.validationMessages.prenom.required });
      return true;
    }
    // if (this.form.value.Profile === '' || this.form.value.Profile === undefined) {
    //   this.msgs = []; this.msgs.push({ severity: 'warning', summary: 'info', detail: this.validationMessages.profile.required });
    //   return true;
    // }
    if (this.form.value.role === '' || this.form.value.role === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'warning', summary: 'info', detail: this.validationMessages.role.required });
      return true;
    }
    if (this.form.value.password === '' || this.form.value.password === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'warning', summary: 'info', detail: this.validationMessages.password.required });
      return true;
    }
    if (!this.validateConfirmPass()) {
      this.msgs = []; this.msgs.push({ severity: 'warning', summary: 'info', detail: this.validationMessages.confirmation.confirm });
      return true;
    }
    return false;
  }

  validateConfirmPass(): boolean {
    const mypass = this.form.value.password;
    const confirm = this.form.value.confirmer;
    if (mypass === confirm) {
      return true;
    } else {
      return false;
    }
  }

  retour() {
    console.log('retour: ');
    this.displayDialog = false;
  }
}

